import analytics from "../analytics/analytics.js";
import fetchWithTimeout from "../utils/fetchWithTimeout.js";
const CREATE_BASKET_MUTATION = `
mutation CreateBasket($basketPayload: CreateBasketPayload) {
  createBasket(basketPayload: $basketPayload) {
    checkoutUrl
  }
}
`;
const createBasketRequest = (options)=>{
    const { appc, itemKey, itemType, priceKey, total, minCurrencyCode = 'USD', minCurrencyCodeSymbol = '$', cguid, rguid } = options;
    const requestBody = {
        operationName: 'CreateBasket',
        query: CREATE_BASKET_MUTATION,
        variables: {
            basketPayload: {
                item: {
                    itemKey,
                    itemType,
                    priceKey
                },
                meta: {
                    appc,
                    cguid,
                    rguid,
                    plf: 'PCLN',
                    gpcd: 'PCLN',
                    pointOfSale: {
                        countryCode: 'US',
                        languageCode: 'ENG',
                        currencyCode: 'USD'
                    },
                    authToken: null
                },
                price: {
                    currencyCode: minCurrencyCode,
                    currencySymbol: minCurrencyCodeSymbol,
                    payment: {
                        total: Number(total)
                    }
                }
            }
        }
    };
    fetchWithTimeout("/pws/v0/pcln-graph/?gqlOp=CreateBasket", {
        method: 'POST',
        body: JSON.stringify(requestBody),
        headers: {
            'Content-Type': 'application/json'
        }
    }, 10000).then((res)=>res.json()).then((createBasketResponse)=>{
        if (createBasketResponse?.data?.createBasket?.checkoutUrl) {
            const ref = window.open(createBasketResponse.data.createBasket.checkoutUrl, '_blank');
            if (!ref) alert('Please allow pop-ups in your browser. Thanks!');
        } else throw new Error('no checkout url');
    }).catch((err)=>{
        alert('Redirect failed. Please retry or use the detail link. Thanks!');
        analytics.logError({
            message: 'Error creating basket',
            error: err.message
        });
    });
};
export { createBasketRequest };
